import reduceRunsInboxModal, {RunsInboxModalState} from 'runs/inbox/reduceRunsInboxModal';
import combineBenchlingReducers from 'util/combineBenchlingReducers';

export interface ResultsUIState {
  runsInboxModal: RunsInboxModalState;
}

export default combineBenchlingReducers({
  runsInboxModal: reduceRunsInboxModal,
});
